import { getBlockTypes } from "@/Api";
import { useEffect, useState } from "react";
import { Header, Table } from "react-frontier";
import type { BlockType } from "@/Classes";

var ListComponents=()=>{
   var[error,setError]=useState<string>(null);
   var[blockTypes,setBlockTypes]=useState<BlockType[]>(null);

   var get=()=>{
      getBlockTypes().then(res=>{
         if(res.error) return setError(res.message);
         setBlockTypes(res.data);
      }).catch(()=>{
         setError('Ocurrio un error al obtener la lista de componentes.');
      });
   };

   useEffect(()=>{
      get();
   },[]);

   if(error) return <Header text={error} />;

   return <div style={{ padding: '60px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
      <Header text="Componentes de documento" subtext="Lista de componentes disponibles para el maquetado de documentos." />
      
      <Table
         fitted
         striped
         title='Componentes'
         style={{ width: '800px' }}
         collapsingIndexes={[0,2]}
         headers={['ID', 'Nombre', 'Slug', 'Descripción']}
      >
         {!blockTypes ? (
            <Table.Row>
               <Table.Cell className="empty" colSpan={4}><Header loading /></Table.Cell>
            </Table.Row>
         ) : blockTypes.length > 0 ? blockTypes.map(bt => (
            <Table.Row 
               key={bt.block_type_id}
               data={[
                  bt.block_type_id,
                  bt.name,
                  bt.slug_name,
                  bt.description || '-'
               ]}
            />
         )) : (
            <Table.Row>
               <Table.Cell className='empty' colSpan={4}>No se encontraron componentes</Table.Cell>
            </Table.Row>
         )}
      </Table>
   </div>;
};

export default ListComponents;
